import { render, staticRenderFns } from "./My360Errors.vue?vue&type=template&id=2b81e7cd&lang=html&"
import script from "./My360Errors.vue?vue&type=script&lang=js&"
export * from "./My360Errors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports